import { createSettingDefaultAction } from "../services/ServiceHelper";
import { signUp } from "../services/UserService";
import { getLocations, getEthnicities } from "../services/LookupService";
import { createActionThunk } from "redux-thunk-actions";
import {
  SIGN_UP_DEFAULT,
  SIGN_UP_INITIALIZATION,
  SIGN_UP_SUBMIT,
  SIGN_UP_SUBMIT_VALIDATION,
  ON_CHANGE_SIGNUP_FORM,
  RESET_FORM,
} from "./constant";
import {reset} from "redux-form";

const setDefaultState = createSettingDefaultAction(SIGN_UP_DEFAULT);
const formInitialization = createActionThunk(
  SIGN_UP_INITIALIZATION,
  (formInitialValues) =>
    Promise.all([getLocations(), getEthnicities(), formInitialValues])
);
const signUpSubmit = createActionThunk(SIGN_UP_SUBMIT, (user) => signUp(user));

const submitValidation = (message) => {
  return (dispatch) => {
    dispatch({
      type: SIGN_UP_SUBMIT_VALIDATION,
      message: message,
    });
  };
};
const onChangeForm = (value) => {
  return (dispatch) => {
    dispatch({
      type: ON_CHANGE_SIGNUP_FORM,
      item: value,
    });
  };
};

const onResetForm = () => {
  return (dispatch) => {
    dispatch(reset('formSignUp'))
    dispatch({type: RESET_FORM})
  }
}

export default {
  setDefaultState,
  formInitialization,
  signUpSubmit,
  onResetForm,
  submitValidation,
  onChangeForm,
};



// WEBPACK FOOTER //
// ./src/actions/signUpActions.js